import { Modal, message, Col, Row } from "antd";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./PurchaseOptionsModalPhone.css";
import { NumericInput } from "../Reusable/NumericInput";
import { BuyNowButton } from "../Reusable/BuyNowButton";
import { useMobxStores } from "../../../stores/stores";
import { observer } from "mobx-react";

const PurchaseOptionsModal = ({ isOpen, handleClose }) => {
  const { marketplaceStore } = useMobxStores();
  const [totalData, setTotalData] = useState([]);

  const params = useParams();

  const sellerColumn = [
    { title: "Seller", dataIndex: "seller_username", key: "seller_username" },
    { title: "Quantity", dataIndex: "quantity", key: "quantity" },
    { title: "Price/Unit", dataIndex: "pricePerUnit", key: "pricePerUnit" },
    { title: "Total Price", dataIndex: "total_price", key: "total_price" },
    { title: "", dataIndex: "purchaseControls", key: "purchaseControls" },
  ];

  const totalPriceColumn = [
    {
      title: "Total",
      dataIndex: "totalQuantity",
      key: "totalQuantity",
    },
    {
      title: "",
      dataIndex: "totalPrice",
      key: "totalPrice",
    },
    {
      title: "",
      dataIndex: "buyNow",
      key: "buyNow",
    },
  ];

  const handleInputChange = (id, seller_username, price_per_unit, quantity) => {
    setTotalData((prevState) => {
      let updatedData = [...prevState];
      const existingIndex = updatedData.findIndex((item) => item.id === id);

      if (quantity === 0) {
        updatedData = updatedData.filter((item) => item.id !== id);
      } else if (existingIndex !== -1) {
        updatedData[existingIndex] = {
          ...updatedData[existingIndex],
          totalQuantity: quantity,
          total_price: price_per_unit * quantity,
        };
      } else {
        updatedData.push({
          id: id,
          username: seller_username,
          totalQuantity: quantity,
          total_price: price_per_unit * quantity,
        });
      }
      return updatedData;
    });
  };

  const handleBuy = async (listingId, quantity) => {
    if (!marketplaceStore?.marketplaceItem) return;

    const metamaskData = localStorage.getItem("metaMask");
    if (!metamaskData) {
      message.error("Please connect to Metamask first");
      return;
    }

    marketplaceStore.setBuyInProgress(true);
    try {
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [
          {
            chainId: `0x${marketplaceStore.marketplaceItem.item.chainid.toString(
              16
            )}`,
          },
        ],
      });
      var values = {
        account: metamaskData,
        listing: listingId,
        quantity: quantity,
      };
      handleClose();
      await marketplaceStore.BuyNFT(
        marketplaceStore.marketplaceItem.item.nft,
        values
      );

      marketplaceStore.GetMarketplaceItemById(params.pk);
    } catch (error) {
      handleClose();
      console.error(error);
    } finally {
      marketplaceStore.setBuyInProgress(false);
    }
  };

  const isItemInCart = (id) => {
    return marketplaceStore.cart.items.includes(id);
  };

  const handleAddToCart = async (listingsData) => {
    marketplaceStore.setCartCurrency(
      marketplaceStore.marketplaceItem.item.chainid
    );

    const purchaseInfo = [];
    for (let i = 0; i < listingsData.length; i++) {
      purchaseInfo.push({
        listing: listingsData[i].id,
        quantity: listingsData[i].totalQuantity,
      });
    }

    if (!isItemInCart(marketplaceStore.marketplaceItem.item.id)) {
      let values = { ...marketplaceStore.cart };
      values.items.push(marketplaceStore.marketplaceItem.item.id);
      values.purchase_info.push(...purchaseInfo);
      marketplaceStore.UpdateCart({
        items: values.items,
        purchase_info: values.purchase_info,
      });
      message.success("Item added to cart");
      handleClose();
    } else if (isItemInCart(marketplaceStore.marketplaceItem.item.id)) {
      const values = { ...marketplaceStore.cart };
      marketplaceStore.UpdateCart({
        items: values.items,
        purchase_info: purchaseInfo,
      });
      message.success("Item added to cart");
      handleClose();
    } else {
      message.warning("Item already in cart");
    }
  };

  return (
    <Modal
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      width={1000}
      styles={{ body: { minHeight: "320px" } }}
      title={
        <span style={{ color: "#000080", fontWeight: "600", fontSize: "20px" }}>
          Purchase options
        </span>
      }
    >
      <div className="seller-table-container">
        {/* <div className="seller-table-header">
          {sellerColumn.map((col) => (
            <div key={col.key} className="seller-table-cell header">
              {col.title}
            </div>
          ))}
        </div> */}
        <div
        // className="seller-table-body"
        >
          {marketplaceStore.listings.map((row) => {
            const pricePerUnit =
              row.quantity > 0 ? row.total_price / row.quantity : 0;

            return (
              <div className="seller-card">
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "6px",
                  }}
                >
                  <div className="seller-name">
                    <Link className="custom-link">@{row.seller_username}</Link>
                  </div>
                </Row>
                <Row>
                  <Col span={18}>
                    {" "}
                    <div key={row.id}>
                      <div className="seller-table-cell">
                        Quantity: {" " + row.quantity}
                      </div>
                      <div className="seller-table-cell">
                        Price/Unit:
                        {pricePerUnit % 1 !== 0
                          ? " " + pricePerUnit.toFixed(5)
                          : " " + pricePerUnit}{" "}
                        {marketplaceStore.NFT.chainid === 11155111
                          ? "ETH"
                          : "MATIC"}
                      </div>
                      <div className="seller-table-cell">
                        Total Price: {" " + row.total_price}
                        {marketplaceStore.NFT.chainid === 11155111
                          ? "ETH"
                          : "MATIC"}
                      </div>
                    </div>
                  </Col>
                  <Col
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                    span={6}
                  >
                    {" "}
                    <div
                    // className="seller-table-cell"
                    >
                      <NumericInput
                        initialValue={
                          marketplaceStore.cart.purchase_info?.find(
                            (item) => item.listing === row.id
                          )?.quantity ?? 0
                        }
                        min={0}
                        max={row.quantity}
                        handleChange={(value) =>
                          handleInputChange(
                            row.id,
                            row.seller_username,
                            pricePerUnit,
                            value
                          )
                        }
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            );
          })}
        </div>
      </div>
      {totalData.length > 0 && (
        <div className="seller-table-container">
          <div className="total-price-table-header">
            {totalPriceColumn.map((col) => (
              <div key={col.key} className="seller-table-cell header">
                {col.title}
              </div>
            ))}
          </div>
          <div className="seller-table-body">
            {totalData?.map((row) => (
              <div key={row.id} style={{ borderBottom: "0.1px solid #615f5f" }}>
                <div className={"total-price-table-cell"}>
                  {row.totalQuantity}{" "}
                  {row.totalQuantity > 1 ? "editions" : "edition"} from{" "}
                  <Link className="custom-link">@{row.username}</Link>
                </div>
                <div style={{ display: "flex", justifyContent: "end" }}>
                  {row.total_price}{" "}
                  {marketplaceStore.NFT.chainid === 11155111 ? "ETH" : "MATIC"}
                </div>
              </div>
            ))}
            <div>
              <div>
                <Row
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>
                    {totalData.reduce(
                      (acc, current) => current.totalQuantity + acc,
                      0
                    )}{" "}
                    {totalData.reduce(
                      (acc, current) => current.totalQuantity + acc,
                      0
                    ) > 1
                      ? "editions"
                      : "edition"}
                  </span>
                  <span>
                    {totalData.reduce(
                      (acc, current) => current.total_price + acc,
                      0
                    )}{" "}
                    {marketplaceStore.NFT.chainid === 11155111
                      ? "ETH"
                      : "MATIC"}
                  </span>
                </Row>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "12px",
                }}
              >
                <BuyNowButton
                  isBuyNowDisabled={totalData.length > 1}
                  isAddToCartDisabled={
                    marketplaceStore.cartCurrency !== "" &&
                    marketplaceStore.NFT.chainid !==
                      marketplaceStore.cartCurrency
                  }
                  handleBuy={() =>
                    handleBuy(totalData[0].id, totalData[0].totalQuantity)
                  }
                  handleAddToCart={() => handleAddToCart(totalData)}
                  size={"small"}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default observer(PurchaseOptionsModal);
